import axios from 'axios';

// const API_BASE_URL = 'http://localhost:5000/v1/';
const API_BASE_URL = 'https://api.prod.justgold.me/v1/';

// Create an Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {},
});

const apiV1 = axios.create({
  baseURL: 'https://api.justgold.me/api/v1/',
  headers: {},
});




// Add a response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);

    // Only handle 401 errors if they are from a real API response
    if (error.response && error.response.status === 401) {
      console.log('API - 401 Unauthorized error');
      // Don't redirect immediately, let the component handle it
      // redirectToLogin();
    }
    return Promise.reject(error);
  }
);

// Function to handle API requests
const apiRequest = async (endpoint, method, data = null) => {
  const headers = data instanceof FormData ? {} : { 'Content-Type': 'application/json' };

  // Don't include `data` key for GET/DELETE
  const config = {
    url: endpoint,
    method,
    headers,
    ...(method !== 'GET' && data && { data }),
  };

  try {
    console.log(`API Request: ${method} ${endpoint}`);
    const response = await api(config);
    return response.data;
  } catch (error) {
    console.error('API Request Error:', error);

    if (
      error.response &&
      error.response.data &&
      (error.response.data.message === 'Unauthorized access. Token verification failed.' ||
        error.response.status === 401)
    ) {
      console.log('API - Token verification failed');
    }

    throw error;
  }
};

const apiRequestV1 = async (endpoint, method, data = null) => {
  const headers = data instanceof FormData ? {} : { 'Content-Type': 'application/json' };

  // Don't include `data` key for GET/DELETE
  const config = {
    url: endpoint,
    method,
    headers,
    ...(method !== 'GET' && data && { data }),
  };

  try {
    console.log(`API Request: ${method} ${endpoint}`);
    const response = await apiV1(config);
    return response.data;
  } catch (error) {
    console.error('API Request Error:', error);

    if (
      error.response &&
      error.response.data &&
      (error.response.data.message === 'Unauthorized access. Token verification failed.' ||
        error.response.status === 401)
    ) {
      console.log('API - Token verification failed');
    }

    throw error;
  }
};


export const scheduleDemo = async (data) => {
	const response = await fetch(`${API_BASE_URL}landing/schedule-demo`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});
	 return response;
};

export const uploadToS3 = (data) =>{
  return apiRequest('/upload/file', 'POST', data);
};


export const submitPDPLRequest = (data) =>{
  return apiRequest('/pdpl/submit', 'POST', data);
};
 
export const getAllBlogs = async () => {
  // const res = await fetch('http://localhost:3000/v1/blogs/', { cache: 'no-store' });
  const res = await fetch('https://api.prod.justgold.me/v1/blogs/', { cache: 'no-store' });
  const data = await res.json();
  console.log(data);
  return data;
};


export const getAllBlogsV1 = async () => {
	return apiRequestV1('/blogs', 'GET');
};
 
export const getBlogBySlug = async (slug) => {
  console.log("Incoming slug:", slug);
  try {
    const res = await fetch(`https://api.prod.justgold.me/v1/blogs/slug/${encodeURIComponent(slug)}`, { 
    // const res = await fetch(`http://localhost:3000/v1/blogs/slug/${encodeURIComponent(slug)}`, { 
      headers: { 'Content-Type': 'application/json' },
      cache: 'no-store' 
    });
    if (res.status === 404) return null;
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
};

export const getBlogBySlugV1 = async (slug) => {
  console.log("Incoming slug:", slug);
  try {
    const res = await apiRequestV1(`/blogs/slug/${encodeURIComponent(slug)}`, 'GET');
    console.log("API response for slug:", res);
    return res;
  } catch (err) {
    if (err.response?.status === 404) return null;
    throw err;
  }
};
export const getAllBlogsServer = async () => {
  const res = await fetch('https://api.prod.justgold.me/v1/blogs', { 
    cache: 'no-store' 
  });
  const data = await res.json();
  return data;
};



